export default __webpack_public_path__ + "static/media/056-file-2.900c422c.svg";